import { render } from "./MediaDocsLinksDialog.vue?vue&type=template&id=38aef40e&scoped=true"
import script from "./MediaDocsLinksDialog.vue?vue&type=script&lang=js"
export * from "./MediaDocsLinksDialog.vue?vue&type=script&lang=js"

import "./MediaDocsLinksDialog.vue?vue&type=style&index=0&id=38aef40e&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38aef40e"]])

export default __exports__